export default "__VITE_ASSET__BAT10PMN__ 1920w";